<section>
  <app-video-upload
    [filterValues]="filters"
  >
    <app-video-query-elements
      [allowEmptyValues]="false"
      [(queryElementsConfig)]="queryElementsConfig"
      (filtersChange)="onFiltersChange($event)"
    >
      <div
        app-video-category-selector-extra
        *ngIf="filters?.category === 'other'"
      >
        <div class="extra-input">
          <input
            type="text"
            class="input"
            placeholder="Escribe el nombre de la nueva categoría"
            [(ngModel)]="otherCategory"
          />
        </div>
      </div>
      <div
        app-video-competition-selector-extra
        *ngIf="filters?.competition === 'other'"
      >
        <div class="extra-input">
          <input
            type="text"
            class="input"
            placeholder="Escribe el nombre de la nueva competición"
            [(ngModel)]="otherCompetition"
          />
        </div>
      </div>
      <div
        app-video-championship-selector-extra
        *ngIf="filters?.championship === 'other'"
      >
        <div class="extra-input">
          <input
            type="text"
            class="input"
            placeholder="Escribe el nombre del nuevo campeonato"
            [(ngModel)]="otherChampionship"
          />
        </div>
      </div>
    </app-video-query-elements>
  </app-video-upload>
</section>
